// extracted by mini-css-extract-plugin
module.exports = {"header":"items_list_header__1RNLA","item":"items_list_item___cH1A"};